import {
  WHEEL_TYPE_ALL,
  WHEEL_TYPE_GET,
  WHEEL_TYPE_POST,
  WHEEL_TYPE_PUT,
  WHEEL_TYPE_DELETE,
  WHEEL_TYPE_LOADING,
  WHEEL_TYPE_ERROR,
  WHEEL_TYPE_RESET,
} from '../../actions/types';

const initialState = {
  wheel: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WHEEL_TYPE_LOADING:
      return { isLoading: true, isCompleted: false };
    case WHEEL_TYPE_ERROR:
      return { isLoading: false, isCompleted: false };
    case WHEEL_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_TYPE_POST:
      return { isLoading: false, isCompleted: true };
    case WHEEL_TYPE_PUT:
      return { isLoading: false, isCompleted: true };
    case WHEEL_TYPE_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
